// extracted by mini-css-extract-plugin
export default {"field-supporting-text":"FieldSupportingText_field-supporting-text__KKMpK"};